import { render, staticRenderFns } from "./ComposerOutput.vue?vue&type=template&id=3407cfb9&"
import script from "./ComposerOutput.vue?vue&type=script&lang=js&"
export * from "./ComposerOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports